module.exports = __webpack_public_path__ + "img/default.a10caf9e.svg";